import React from 'react';
import { Steps } from 'antd';

import styles from './BaseProgressTrackerWrapper.module.less';

type Props = {
  children: React.ReactNode;
};
export default function BaseProgressTrackerWrapper(props: Props) {
  const { children } = props;

  return (
    <div className="progress-step-wrapper">
      <div className={styles.progressStep}>
        <Steps labelPlacement="vertical" direction="horizontal">
          {children}
        </Steps>
      </div>
    </div>
  );
}
